import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { ICard } from "@edp-models/benefits.model";
import { EdpModalService } from "@edp-components/edp-modal";
import { IModalData } from "@edp-components/edp-modal/edp-modal.models";
import { Subscription, of } from "rxjs";
import { BenefitsService } from "@edp-services/benefits.service";
import { switchMap, catchError } from "rxjs/operators";
import { ExternalLinkService } from "@edp-directives/external-link/external-link.service";
import { Store } from "@ngrx/store";
import { IAppState } from "@edp-store/state/app.state";
import { GetAvailable } from "@edp-store/actions/benefits.actions";
import { GetRatingStatus } from "@edp-store/actions/rating.actions";
import { Router } from "@angular/router";
import { GoogleAnalyticsService } from "@edp-services/google-analytics.service";
import { ActiveItemSidebarAction } from "@edp-store/actions/layout.actions";
import { BenefitsRoute } from "@edp-models/benefits-route";
import { GetDashboardSections } from "@edp-store/actions/edpe.actions";

declare function hj(name: string, params: any): void;

@Component({
    selector: "edp-e-submit-giveaway-modal",
    templateUrl: "./edp-e-submit-giveaway-modal.component.html",
    styleUrls: ["./edp-e-submit-giveaway-modal.component.scss"],
})
export class EdpESubmitGiveawayModalComponent implements OnInit, OnDestroy {
    @Input() data: IModalData;
    public conditionTermsChecked: boolean;
    public card: ICard;
    public error: string;
    public success: boolean;
    public showErrorMessage = false;
    public loading = false;
    public btnLink = false;
    public benefits: BenefitsRoute;
    private subscription = new Subscription();

    constructor(
        private edpModalService: EdpModalService,
        private benefitsService: BenefitsService,
        private store: Store<IAppState>,
        private externalLinkService: ExternalLinkService,
        private router: Router,
        private googleAnalyticsService: GoogleAnalyticsService
    ) {
        this.benefits = {
            route: "/beneficios",
            param: { Type: "Sorteio a decorrer", Area: "Planeta Zero" },
            activeSidebar: "beneficios",
        };
    }

    ngOnInit(): void {
        this.card = this.data.collection;
        this.success = false;
        this.loading = false;
        this.showErrorMessage = false;
    }

    public closeModal(action: boolean): void {
        this.edpModalService.close(action);
    }

    public onClick(event: { target: { checked: boolean; }; }) {
        this.conditionTermsChecked = event.target.checked;
    }

    public termsAndConditions() {
        this.externalLinkService.externalLink(this.card.termsAndConditions);
    }

    public submit() {
        this.loading = true;
        this.subscription = this.benefitsService
            .submitGiveaway(this.card.eventName, this.card.cardSubTypeAcronym, this.card.id)
            .pipe(
                switchMap(resp => of(resp)),
                catchError(error => of(error))
            )
            .subscribe(resp => {
                if (resp instanceof Error) {
                    this.success = false;
                    this.error = resp.message;
                    this.showErrorMessage = true;
                    this.loading = false;
                } else {
                    this.success = true;
                    this.store.dispatch(new GetAvailable());
                    this.store.dispatch(new GetDashboardSections());
                    this.showErrorMessage = true;
                    this.loading = false;
                    this.store.dispatch(new GetRatingStatus());
                    if (this.card.cardSubTypeAcronym === "DRAW") {
                        this.googleAnalyticsService.datalayerEvent("SUBSCRIPTION_DRAW");
                    }

                    // Noocity hotjar exception
                    if (this.card.id === 79 && typeof hj === "function") {
                        hj("trigger", ["hj_feedback_planeta"]);
                    }
                }
            });
        this.btnLink = true;
    }

    onClickLink(benefits: BenefitsRoute) {
        this.store.dispatch(new ActiveItemSidebarAction(benefits.activeSidebar));
        this.closeModal(false);
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
